import { render, staticRenderFns } from "./template.html?vue&type=template&id=b52e0aac&scoped=true&external"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=b52e0aac&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52e0aac",
  null
  
)

export default component.exports